import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { FaStethoscope } from 'react-icons/fa';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import { useItems } from '../../hooks/atoms/items-hook';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import AppLoader from '../basic/AppLoader';
import DoctorKitCorrelationTable from './doctor-kit-correlation/DoctorKitCorrelationTable';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const DoctorKitCorrelationPage = () => {
  const classes = useStyles();

  const {
    itemsLoading: doctorsLoading,
    count: totalEntries,
  } = useItems(CollectionKeys.CUSTOMER_DOCTOR_KITS);

  if (doctorsLoading) {
    return <AppLoader />;
  }
  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <FaStethoscope
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Doctor - Kit Correlation'
          subtitle={ `Entries: ${ totalEntries }` }
          actions={ (
            <>
            </>
          ) }
        />
      </div>
      <DoctorKitCorrelationTable />
    </div>
  );
};

export default DoctorKitCorrelationPage;
